export default __webpack_public_path__ + "static/media/(34)-min.794cb5a5.jpg";